import { Component, OnInit } from '@angular/core';
import { FlashMessagesService } from '../service/flash.messages.service';
import { FlashMessage, MessageLevel } from '../flash.message.record';
import { Observable } from 'rxjs/Observable';
import { LogService } from '../../log/log.service';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Component({
  selector: 'pioneer-flash-messages',
  templateUrl: './flash.messages.component.html',
  styleUrls: [ './flash.messages.component.css' ]
})
export class FlashMessagesComponent implements OnInit {

  messages: FlashMessage[] = [];

  constructor(private flashMessagesService: FlashMessagesService,
              private logService: LogService,
              private environment: EnvironmentConfiguration) {
  }

  ngOnInit() {
    this.flashMessagesService.messages.subscribe(newMessage => {
      this.show(newMessage);
    });
  }

  get alertTimer(): number {
    return this.environment.alertMessageTimer != null ? this.environment.alertMessageTimer : 3500;
  }

  /**
   * Removes any non-persistent error messages.
   * Unless specified, no error messages are persistent.
   * For other messages, they will close via timerClose
   * unless specified as persistent.
   */
  clearNonPersistentMessages(): void {
    this.messages = this.messages.filter(message => message.displayThroughNavigation);
  }

  show(newMessage: FlashMessage): void {
    this.logService.debug(`Received message ${JSON.stringify(newMessage)}`);
    this.messages.push(newMessage);
    this.timerClose(newMessage);
  }

  findClass(message: FlashMessage): string {
    let messageCssClass: string;

    switch (message.level) {
      case MessageLevel.ERROR:
        messageCssClass = 'alert-danger';
        break;
      case MessageLevel.SUCCESS:
        messageCssClass = 'alert-success';
        break;
      case MessageLevel.WARN:
        messageCssClass = 'alert-warning';
        break;
      default: {
        messageCssClass = 'alert-info';
      }
    }

    return messageCssClass;
  }

  closeMessage(message: FlashMessage) {
    this.remove(message);
  }

  showClose(message: FlashMessage): boolean {
    return !message.autoClose;
  }

  private timerClose(message: FlashMessage) {
    if (message.autoClose) {
      /**
       * .take(1) ensures that interval(this.alertTimer)  only happens once and then cleans up the observable.
       * Otherwise, the selenium tests will timeout waiting for the flashMessage interval to resolve.
       */
      Observable.interval(this.alertTimer).take(1).subscribe(() => {
        this.logService.debug(`Observable.timer executing for id: ${message.id}`);
        this.remove(message);
      });
    }
  }

  private remove(message: FlashMessage) {
    this.messages = this.messages.filter((value, key) => value.id !== message.id);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/flash-messages/component/flash.messages.component.ts